import { apiClient, type ApiResponse } from './client'
import type {
  ChapterReportEditResult,
  ChapterReportView,
  UpdateChapterReportInput,
  UpdateCoachingNoteResult,
} from '@/types/chapterReport'

export const chapterReportsApi = {
  resolve: async (learnerId: number, testId: number): Promise<{ reportId: number }> => {
    const response = await apiClient.post<ApiResponse<{ reportId: number }>>(
      `/lc/admin/coaching/learners/${learnerId}/tests/${testId}/chapter-report`,
      {},
    )
    return response.data.data
  },

  get: async (learnerId: number, reportId: number): Promise<ChapterReportView> => {
    const response = await apiClient.get<ApiResponse<ChapterReportView>>(
      `/lc/admin/coaching/learners/${learnerId}/chapter-reports/${reportId}`,
    )
    return response.data.data
  },

  update: async (
    learnerId: number,
    reportId: number,
    input: UpdateChapterReportInput,
  ): Promise<ChapterReportEditResult> => {
    const response = await apiClient.put<ApiResponse<ChapterReportEditResult>>(
      `/lc/admin/coaching/learners/${learnerId}/chapter-reports/${reportId}`,
      input,
    )
    return response.data.data
  },

  updateAttendanceNote: async (
    learnerId: number,
    attendanceId: number,
    note: string | null,
    expectedVersion: number,
  ): Promise<UpdateCoachingNoteResult> => {
    const response = await apiClient.patch<ApiResponse<UpdateCoachingNoteResult>>(
      `/lc/admin/coaching/learners/${learnerId}/attendances/${attendanceId}/note`,
      { note, expectedVersion },
    )
    return response.data.data
  },
}
